import { axiosInstance } from "../utils/axios";

// Get users API
export const getUsersApi = async () => {
  return await axiosInstance.get(`/meeting-hub/users`);
};

// GET Users By Company
export const getUsersByCompanyApi = async (id, startDate, endDate) => {
  return await axiosInstance.get(`/meeting-hub/users/company/${id}?startDate=${startDate}&endDate=${endDate}`);
};
